import axios from "axios";
import store from './store';
import router from './router'
import { Preferences } from '@capacitor/preferences';
//console.log(store);
class axiosHttp {
  constructor () {
    if(process.env.NODE_ENV === 'development') {
      store.dispatch("auth/SET_API_URL", process.env.VUE_APP_API_URL);
    } else {
      store.dispatch("auth/SET_API_URL", 'https://api.' + window.location.host.slice(2)); // Slice pour enlever le 'm.'
    }
    this.http = axios.create({
      baseURL: store.state.auth.apiUrl,
      headers: {
        "Content-type": "application/json"
      }
    })

    this.http.interceptors.request.use(async config => {
      config.headers.Token = store.state.auth.accessToken
      config.headers.APPMOBILE = true
      if(store.state.auth.currentAccountId != 0){
        config.headers.ACCOUNTID = store.state.auth.currentAccountId
      }
      const { value } = await Preferences.get({ key: 'account_id' });
      if(value && value != 0){
        config.headers.ACCOUNTID = value
      }
      return config
    })
  }
}
export default new axiosHttp();